/**
 * Deterministic QR-looking placeholder, ported from the design doc.
 * It is decorative — the modules are seeded noise around real finder patterns,
 * not an encodable payload.
 */
export function qrDataUri(seed: number): string {
  const N = 25
  const quiet = 2
  const size = N + quiet * 2

  let x = 0
  const rnd = () => {
    x = (x * 1103515245 + 12345 + seed) % 2147483648
    return x / 2147483648
  }
  for (let i = 0; i < 8; i++) rnd()

  const finder = (r: number, c: number): boolean | null => {
    const inBox = (r0: number, c0: number) => r >= r0 && r < r0 + 7 && c >= c0 && c < c0 + 7
    const ring = (r0: number, c0: number) => {
      const dr = r - r0
      const dc = c - c0
      const edge = dr === 0 || dr === 6 || dc === 0 || dc === 6
      const core = dr >= 2 && dr <= 4 && dc >= 2 && dc <= 4
      return edge || core
    }
    if (inBox(0, 0)) return ring(0, 0)
    if (inBox(0, N - 7)) return ring(0, N - 7)
    if (inBox(N - 7, 0)) return ring(N - 7, 0)
    return null
  }

  let rects = ''
  for (let r = 0; r < N; r++) {
    for (let c = 0; c < N; c++) {
      const fin = finder(r, c)
      const on = fin === null ? rnd() > 0.52 : fin
      if (on) rects += `<rect x="${c + quiet}" y="${r + quiet}" width="1" height="1"/>`
    }
  }

  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${size} ${size}" shape-rendering="crispEdges">` +
    `<rect width="${size}" height="${size}" fill="#fff"/>` +
    `<g fill="#141415">${rects}</g></svg>`

  return 'data:image/svg+xml,' + encodeURIComponent(svg)
}
